module.exports = __webpack_public_path__ + "static/media/CloseButton.2f9e1b32.svg";